import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateColorProfileComponent } from './create-color-profile.component';
import { SharedModule } from 'app/shared/shared.module';
import { MetaFieldSelectorModule } from '../meta-field-selector/meta-field-selector.module';



@NgModule({
  declarations: [
    CreateColorProfileComponent
  ],
  exports: [
    CreateColorProfileComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MetaFieldSelectorModule
  ]
})
export class CreateColorProfileModule { }
